import { Slide } from "@jelly/lesson";
import theory from "../../theory";

import { extraContent as extraContentS191, components as componentsS191 } from "./components/s-1-91";
import { extraContent as extraContentS212, components as componentsS212 } from "./components/s-2-12";
import { extraContent as extraContentS236, components as componentsS236 } from "./components/s-2-36";
import { extraContent as extraContentS293, components as componentsS293 } from "./components/s-2-93";
import { extraContent as extraContentS373, components as componentsS373 } from "./components/s-3-73";

const principle: Slide = {
  description:
    "Sharpness is a psychoacoustic quantity reflecting the sensation induced by high frequency components.  Sounds with a higher amount of high frequency components (i.e. where the spectral distribution is shifted towards higher frequencies) will be perceived as being sharper.",
  theory: theory,
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controls: [
        {
          type: "button",
          options: {},
          items: [
            {
              name: "S = 1.91 acum",
            },
            {
              name: "S = 2.12 acum",
            },
            {
              name: "S = 2.36 acum",
            },
            {
              name: "S = 2.93 acum",
            },
            {
              name: "S = 3.73 acum",
            },
          ],
        },
      ],
      extraContent: [extraContentS191, extraContentS212, extraContentS236, extraContentS293, extraContentS373],
      components: [componentsS191, componentsS212, componentsS236, componentsS293, componentsS373],
    },
  },
};

export default principle;
